import * as React from 'react';
import b_ from 'b_';
import './index.scss';

interface Props {
  account?: boolean;
}

const b = b_.with('page-content');

export const PageWrapper: React.FC<Props> = ({ children, account }) => {
  return <div className={b({ account })}>{children}</div>;
};
